// Normalisierung der DB-Werte. Über verschiedene Import- und Eingabewege sind
// für dieselbe Qualifikation sowohl Kurzcodes (z.B. "nfs") als auch volle
// Bezeichnungen (z.B. "Notfallsanitäter") in der DB gelandet. Diese Helfer
// bilden beide Varianten auf den kanonischen Kurzcode ab, der vom Frontend
// (Select-Optionen, Counter, Übersicht) erwartet wird.

const norm = (v) => (v == null ? '' : String(v).trim().toLowerCase());

export function normalizeProfessional(value) {
    const v = norm(value);
    if (!v || v === 'keine') return null;
    switch (v) {
        case 'eh':
        case 'erste hilfe':
        case 'ersthelfer':
            return 'eh';
        case 'san':
        case 'sanitaeter':
        case 'sanitäter':
        case 'sanität':
        case 'sanitaet':
            return 'san';
        case 'rh':
        case 'rettungshelfer':
            return 'rh';
        case 'rs':
        case 'rettungssanitaeter':
        case 'rettungssanitäter':
            return 'rs';
        case 'ra':
        case 'rettungsassistent':
        case 'rettungsassistenten':
            return 'ra';
        case 'nfs':
        case 'notfallsanitaeter':
        case 'notfallsanitäter':
            return 'nfs';
        case 'arzt':
        case 'ärztin':
        case 'aerztin':
            return 'arzt';
        case 'notarzt':
            return 'notarzt';
        default:
            return value;
    }
}

export function normalizeLeadership(value) {
    const v = norm(value);
    if (!v || v === 'keine') return null;
    switch (v) {
        case 'gf':
        case 'gruppenfuehrer':
        case 'gruppenführer':
            return 'gf';
        case 'zf':
        case 'zugfuehrer':
        case 'zugführer':
            return 'zf';
        case 'vf':
        case 'verbandfuehrer':
        case 'verbandsfuehrer':
        case 'verbandführer':
        case 'verbandsführer':
            return 'vf';
        case 'orgl':
        case 'organisatorischer leiter':
        case 'organisatorischer leiter rd':
        case 'organisatorischer leiter rettungsdienst':
            return 'orgl';
        default:
            return value;
    }
}

export function normalizeEating(value) {
    const v = norm(value);
    if (!v) return null;
    switch (v) {
        case 'normal':
        case 'keine einschraenkung':
        case 'keine einschränkung':
        case 'keine':
            return 'normal';
        case 'glutenfrei':
        case 'gluten':
            return 'glutenfrei';
        case 'vegan':
            return 'vegan';
        case 'vegu':
        case 'vrgu':
        case 'vegan / glutenfrei':
        case 'vegan/glutenfrei':
        case 'vegan glutenfrei':
            return 'vegu';
        default:
            return value;
    }
}
